import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faColumns } from '@fortawesome/pro-regular-svg-icons/faColumns'

export const defaultTranslations = {
    pluginName: 'Image Cards Block',
    pluginDescription: 'Add a row of 1-4 image, title, copy and link cards',
}

export const defaultSettings = {
    Controls: () => <>Controls for this plugin were not provided</>,
    Renderer: () => <>Renderer for this plugin were not provided</>,
    translations: defaultTranslations,
    IconComponent: <FontAwesomeIcon icon={faColumns} size="3x" />,
}
